import ExchangeDetails from './exchange-details.vue';

export default ExchangeDetails;
